/**
 * 文件下载中间件
 * @param ctx
 * @param next
 * @returns
 */
export const arraybufferMiddleware = async (ctx, next) => {
  const {
    cgiInfo,
    requestConfig
  } = ctx;
  const isBuffer = cgiInfo.responseType === 'arraybuffer';
  if (isBuffer) {
    requestConfig.responseType = 'arraybuffer';
  }
  await next();
};
//# sourceMappingURL=base64.js.map
